import {ErrorHandler, Injectable, Injector} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {LocationStrategy, PathLocationStrategy} from '@angular/common';
import {LoggerService} from '../logger/LoggerService';
import * as StackTraceParser from 'error-stack-parser';
import {hash} from '../helpers/crypto';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  async handleError(error) {
    if (!(error instanceof HttpErrorResponse)) {
      const location = this.injector.get(LocationStrategy);
      const logger = this.injector.get(LoggerService);

      const name = error.name || 'Error name not specified';
      const url = location instanceof PathLocationStrategy ? location.path() : '';
      const message = error.message || error.toString();

      await logger.clientError(name, url, message, StackTraceParser.parse(error));
      console.error(error);
    }
  }
}
